class WallOfGratitude {
    constructor() {
        this.$wallFormContainer = $('#cheer-comment-form-wrap')

        if (this.$wallFormContainer.length <= 0) {
            return
        }

        this.currentPage = 1 // Used to load more posts
        this.textAreas = [...document.getElementsByTagName('textarea')].filter(textarea => this._getTextAreaMaxLength(textarea));
        this.$wallForm = this.$wallFormContainer.find('form')
        this.res_messages = {
            'FILL_REQUIRED_FIELDS': 'Please fill out all fields.',
            'GENERAL_ISSUE': 'An issue has occurred. Please try again!',
            'RECAPTCHA_VERIFICATION_FAILED': 'reCAPTCHA verification failed, please try again.'
        }

        this.init()
    }

    savePost() {
        var isValid = this.validate()

        if (!isValid) {
            grecaptcha.reset()
            return
        }

        $.ajax({
            url: '/actions/wallOfGratitude/posts/savePost',
            type: 'POST',
            data: this.$wallForm.serialize(),
            dataType: 'json',
            context: this,
            success: function(res) {
                console.log('response ->', res);
                if (res.status === 200) {
                    this._showThankYou()
                    this._updateShareButtonLinks()
                    this._resetForm()

                    return;
                }

                this._showFormMessage(res.message)
            },
            error: function(err) {
                grecaptcha.reset()

                const statusCode = err.status

                if (statusCode === 403) {
                    this._showFormMessage('There was an error trying to send your message. Please try again.')
                    return
                }

                this._showFormMessage('Server is not responding. Please try again.')
            }
        })
    }

    validate() {
        const comment = $('#comment').val()
        
        if (!comment) {
            this._showFormMessage('FILL_REQUIRED_FIELDS')
            return false
        }

        return true
    }

    _appendPosts(posts) {
        let $wallPostTemplate = $('#wall-post-template')
        let $wallPostContainer = $('.cheer-comments .comment-list')
        let wallPostTemplateHtml = $wallPostTemplate.html()
        let wallHtml = ""

        for (let i = 0; i < posts.length; i++) {
            wallHtml += wallPostTemplateHtml.replace(/{ message }/g, posts[i]['message'])
                .replace(/{ font }/g, posts[i]['font'])
                .replace(/{ color }/g, posts[i]['color'])
        }

        $wallPostContainer.append(wallHtml)

        this._hideLoading()
    }

    _hideLoading() {
        $('.loading').addClass('hide')
    }

    _hideLoadMore() {
        $('.load-more').remove()
        this._hideLoading()
    }

    _loadMorePosts() {
        this._showLoading()

        $.ajax({
            url: '/actions/wallOfGratitude/posts/getMorePosts',
            type: 'GET',
            data: {
                page: this.currentPage
            },
            dataType: 'json',
            context: this,
            success: function(res) {
                if (res.status === 200) {
                    if (res.posts.length <= 0) {
                        this._hideLoadMore()
                        return
                    }

                    this._appendPosts(res.posts)
                    return
                }


            },
            error: function(err) {
                this._hideLoading()
            }
        })
    }

    _resetForm() {
        this.$wallForm[0].reset()
    }

    _showFormMessage(message) {
        const formMessage = this.res_messages[message] ? this.res_messages[message] : message
        this.$wallFormContainer.find('.form-message').text(formMessage)
    }

    _showLoading() {
        $('.loading').removeClass('hide')
    }

    _showThankYou() {
        this.$wallFormContainer.find('.thank-you').addClass('show')
        this.$wallForm.addClass('hidden')
    }

    _updateShareButtonLinks() {
        const siteUrl = document.location.origin + document.location.pathname
        const comment = this.$wallForm.find('#comment').val()

        $('.share.twitter').attr('href', 'http://twitter.com/share?text=' + comment + ' %232020thankful&url=' + siteUrl)
        $('.share.facebook').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + siteUrl + '&quote=' + comment + ' %232020thankful')
    }

    // Textarea
    _appendCharacterCounterDiv() {
        this.textAreas.forEach(textarea => {
            const parentEl = textarea.parentElement;
            const counterDiv = document.createElement('div');
            const counterNumberSpan = document.createElement('span');

            counterDiv.classList.add('character-count');
            counterNumberSpan.innerText = this._getTextAreaMaxLength(textarea);
            counterDiv.appendChild(counterNumberSpan);
            parentEl.appendChild(counterDiv);

            this._updateRemainingCharacterCount(textarea);
        });
    }

    _getTextAreaMaxLength(textarea) {
        return textarea.getAttribute('maxlength') || textarea.getAttribute('data-val-formmaxlength-maxlength');
    }

    // Prevent user from typing more than maxLength characters (taking into account that new lines (\n) are equal to 2 characters)
    _limitTextareaToMaxLengthCharacters(textarea) {
        const characterCount = textarea.value.replace(this.newLineRegex, '--').length; // Get length - Count new lines (\n) as 2 characters
        const maxLength = this._getTextAreaMaxLength(textarea);

        /*
           If characterCount is greater than set maxLength, get the new textarea value by:
               - Taking the current textarea value
               - Replacing all occurrences of New line (\n) with a Carriage Return + New Line (\r\n)
               - Getting the substring of that value using the maxLength as the indexEnd parameter (e.q. If maxLength is 500, return the first 500 characters)
               - Set textarea's value equal to the new textarea value
       */
        if (characterCount > maxLength) {
            let newTextareaValue = textarea.value.replace(this.newLineRegex, '\r\n').substring(0, maxLength); // This value will always be <= the maxLength set

            if (newTextareaValue.replace(this.newLineRegex, '--').length > maxLength) {
                newTextareaValue = newTextareaValue.substring(0, maxLength - 1);
            }

            textarea.value = newTextareaValue;
        }
    }

    _remainingCharacters(element) {
        const characterCount = element.value.replace(this.newLineRegex, '--').length;

        return this._getTextAreaMaxLength(element) - characterCount;
    }

    _updateRemainingCharacterCount(textarea) {
        const parentEl = textarea.parentElement;
        const characterCountEl = parentEl.querySelector('.character-count span');

        characterCountEl.innerText = this._remainingCharacters(textarea);
    }

    _setupEvents() {
        const $btn = $('.cheer-comments .load-more')

        $btn.on('click', () => {
            this.currentPage++
            this._loadMorePosts()
        })

        // Textarea Character Count
        this.textAreas.forEach(textarea => {
            textarea.addEventListener('input', () => {
                this._limitTextareaToMaxLengthCharacters(textarea);
            });

            textarea.addEventListener('keyup', e => {
                this._updateRemainingCharacterCount(e.target);
            });
        });
    }

    init() {
        this._appendCharacterCounterDiv()
        this._setupEvents()
    }
}

export default WallOfGratitude
